import {
  LOGIN_IS_PUBLIC,
  LOGIN_LOADING,
  LOGIN_PAGES_LOADING,
} from './Login.types';
import { Dispatch } from 'redux';
import { httpError, json, fetchGet } from 'common/helpers';
import { LOGIN_AZURE_AD_AUTHORIZED } from '.';
import { IPublicClientApplication } from '@azure/msal-browser';

export function loginLoading(loading: boolean) {
  return {
    type: LOGIN_LOADING,
    payload: loading,
  };
}

export function loginPagesLoading(loading: boolean) {
  return {
    type: LOGIN_PAGES_LOADING,
    payload: loading,
  };
}

export function loginAzureAdAuthorized(authorized: boolean) {
  return {
    type: LOGIN_AZURE_AD_AUTHORIZED,
    payload: authorized,
  };
}

export function loginIsPublic(isPublic: boolean) {
  return {
    type: LOGIN_IS_PUBLIC,
    payload: isPublic,
  };
}

export function authorizeUser(
  token: string,
  dispatch: Dispatch,
  instance: IPublicClientApplication,
) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;

  return fetchGet(`${apiUri}/authentication/authorize`, `${token}`)
    .then(httpError(dispatch, instance))
    .then(json)
    .then((response) => {
      if (response.errorMessage) {
        if (response.loginButtonSetting) {
          sessionStorage.setItem(
            'loginButtonSetting',
            response.loginButtonSetting,
          );
          sessionStorage.setItem('loginErrorMessage', response.errorMessage);
          // error messaging is handled on screen instead of with a popup in this scenario, therefore remove the error message text here
          response.errorMessage = '';
        }
        throw Error(response.errorMessage);
      }
      return response;
    });
}
